import PropTypes from "prop-types";
import styles from "./index.css";
import classnames from "classnames";
import { ITEM_STATE_LOADING_FAILED } from "../../../../state/modules/savedItems/constants";

const ProductTilePlaceholder = ({ itemState }) => (
  <span
    className={classnames(styles.productTilePlaceholder, {
      [styles.pulsing]: itemState !== ITEM_STATE_LOADING_FAILED
    })}
  >
    <div aria-hidden={true} className={styles.productTileContentPlaceholder}>
      <div className={styles.productImagePlaceholder} />
      <div className={styles.titleTextLineOnePlaceholder} />
      <div className={styles.titleTextLineTwoPlaceholder} />
      <div className={styles.priceTextPlaceholder} />
      <div className={styles.fulfilmentPlaceholder} />
      <div className={styles.itemToBagButtonPlaceholder} />
      <div className={styles.notifyMeButtonPlaceholder} />
    </div>
  </span>
);

ProductTilePlaceholder.propTypes = {
  itemState: PropTypes.string.isRequired
};

export default ProductTilePlaceholder;
